export const getObjectByPath = (path, role) => {
  const sidebarData = JSON.parse(localStorage.getItem("sidemenuItems") || `[]`);

  for (const item of sidebarData) {
    if (item.path === path && (!item.roles || item.roles.includes(role))) {
      return { title: item.title, subNav: null };
    }
    if (item.subNav) {
      for (const subItem of item.subNav) {
        if (
          subItem.path === path &&
          (!subItem.roles || subItem.roles.includes(role))
        ) {
          return { title: item.title, subNav: subItem };
        }
      }
    }
  }
  return null;
};
